import React, { useState } from "react";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "../../../../style/buttons.scss";
import { BasketItem } from "../../../models/BasketItem";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../api/apiRoutes";
import { ApiResult } from "../../../models/ApiResult";
import tryCatchRequest from "../../../api/tryCatchRequest";
import { useDispatch, useSelector } from "react-redux";
import { BsBasket3 } from "react-icons/bs";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { setAddToBasketMessage } from "../../../store/alerts/alertsActions";
import useFacility from "../../../../utils/hooks/useFacility";
import { useTranslation } from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import { gaEvent } from "../../../models/ga";
import { useNavigate } from "react-router";
import { FINALIZE_PAGE } from "../../../routes";
import { State } from "../../../store";
import { QntStateItem } from "../../../models/QntStateItem";
interface IProps {
  preBasket: BasketItem[];
  clearBasket: () => void;
  ticketLimit?: number;
  qntState?: QntStateItem[];
}

const PreBasketSummary: React.FC<IProps> = ({ preBasket, clearBasket, ticketLimit, qntState }: IProps) => {
  const { post } = useApiRequest();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useDesktopSize();
  const { scrollToTop } = useParentMessage();
  const facilityIds = useFacility();
  const [alert, setAlert] = useState<string>("");
  const [qnt, setQnt] = useState<number>(0);
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const addBasketRequest = async () => {
    const response = await Promise.all(preBasket.map(async (params) => await post(ADD_TO_BASKET_URL, params)));
    return response.reduce(
      (acc: ApiResult, item: ApiResult) => ({
        isError: item.isError ? item.isError : acc.isError,
        errorTable:
          item.errorTable.length > 0 && item.isError === true ? setAlert(item.errorTable[0]) : finalizeFunction(),
      }),
      {} as ApiResult
    );
  };

  const saveBasket = async () => {
    await tryCatchRequest(
      async () => addBasketRequest(),
      () => clearBasket(),
      dispatch
    );
    scrollToTop();

    //Metoda przejścia do koszyka po poprawnym zakupie
  };

  const finalizeFunction = () => {
    if (saleConfiguration.popupAfterAddTicket === true) {
      dispatch(setAddToBasketMessage(t("dodano_do_koszyka")));
      //  scrollToId('AddToBasketMessage')
    }

    if (saleConfiguration.popupAfterAddTicket === false) {
      setTimeout(() => {
        navigate(FINALIZE_PAGE);
      }, 100);
    }
  };

  const pixelAddBasket = () => {
    if (
      facilityIds === "273" ||
      facilityIds === "1224" ||
      facilityIds === "1200" ||
      facilityIds === "1204" ||
      facilityIds === "1227" ||
      facilityIds === "1214"
    ) {
      gaEvent(
        "...",
        "add_to_cart",
        {
          value: preBasket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0),
          quantity: preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0),
          currency: "PLN",
        },
        "..."
      );

      ReactPixel.fbq("track", "addEventTicketToBasket", {
        value: preBasket[0].price * preBasket[0].qnt,
        quantity: preBasket[0].qnt,
        currency: "PLN",
      });
    }
  };

  const sumBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);
  const ticketsInCurrentBasket = () => {
    if (qntState && qntState.length > 0) {
      setQnt(qntState.reduce((acc: number, item: QntStateItem) => acc + item.count, 0));
    } else {
      setQnt( preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0));
    }
  };

  return (
    <React.Fragment>
      {alert.length > 2 && alert !== t("dodano_bilet_do_koszyka") && <div className="alert alert-red">{alert}</div>}

      <div className="pre-basket-summary flex-end-center">
        <div className="flex-between-center">
          <span>
            {t("suma")}:{" "}
            <b>
              {sumBasket()} {t("zl")}
            </b>
          </span>

          {preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0) > 0 ? (
            <React.Fragment>
              {ticketLimit ? (
                <React.Fragment>
                  <button
                    className="button medium padding-medium button-fill-second"
                    onClick={() => {
                      saveBasket();
                      pixelAddBasket();
                    }}
                  >
                    {isDesktop ? t("dodaj_do_koszyka") : t("dodaj")}
                    <BsBasket3 className="icon" />
                  </button>
                </React.Fragment>
              ) : (
                <button
                  className="button medium padding-medium button-fill-second"
                  onClick={() => {
                    saveBasket();
                    pixelAddBasket();
                  }}
                >
                  {isDesktop ? t("dodaj_do_koszyka") : t("dodaj")}
                  <BsBasket3 className="icon" />
                </button>
              )}
            </React.Fragment>
          ) : (
            <button className="button medium padding-medium button-fill-disable">
              {isDesktop ? t("dodaj_do_koszyka") : t("dodaj")}
              <BsBasket3 className="icon" />
            </button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default PreBasketSummary;
